import getChartPositionsUrl from 'url-constructors/getChartPositionsUrl';
import { ITopicFilterState } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getByUrl from './helper/getByUrl';
import { ProductTypes } from 'types/shared';
import { IChart } from 'components/data-containers/PositionsTable/shared/shared';
import delve from 'dlv';

export interface IPositionsTrackerTableFetch {
  entityType: EntityTypes;
  entityIds: string[];
  countryIds: string[] | number[] | undefined;
  productType: ProductTypes;
  filters: ITopicFilterState | undefined;
}

const positionTrackerInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: IPositionsTrackerTableFetch
): Promise<Response> => {
  try {
    const {
      entityType,
      entityIds,
      countryIds,
      productType,
      filters,
    } = interceptionData;
    const dspAirplayChartIds = [
      1014, // Shazam Top 200 Weekly,
      1007, // Spotify Top 200 Weekly,
      181153, // Radio Airplay Chart,
      // 1013, // iTunes Track Chart,
    ];
    const params = {
      entityType,
      entityIds,
      countryIds: filters?.country || countryIds,
      productType,

      limit: 200,
    };

    const dspAirplayChartPositionsUrl = getChartPositionsUrl({
      ...params,
      chartIds: [...dspAirplayChartIds],
    });

    const officialChartPositionsUrl = getChartPositionsUrl({
      ...params,
      isMainChartFilter: true,
      chartType: 'official',
    });

    const dspChartPositionsData = await getByUrl<any>(
      dspAirplayChartPositionsUrl
    );
    const officialChartPositionsData = await getByUrl<any>(
      officialChartPositionsUrl
    );

    const responseDSP: IChart[] = delve(dspChartPositionsData, [
      'entityData',
      0,
      'charts',
    ]);

    const responseOfficial: IChart[] = delve(officialChartPositionsData, [
      'entityData',
      0,
      'charts',
    ]);

    const response = {
      dspWithAirplayCharts: responseDSP,
      officialCharts: responseOfficial,
    };

    return new Response(JSON.stringify(response));
  } catch (error) {
    return new Response(JSON.stringify({ reason: new Error(error) }));
  }
};

export default positionTrackerInterceptor;
